import type { TFunction } from 'i18next';
import type { Initiative } from '../../../../../api/initiative-client/initiative-client.type';
import { formatInitiativeDate } from '../../../strategy.helpers';

/**
 * Get initiative information to display in the side section
 *
 * @param {Initiative} initiative - The initiative to get information for
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {Array<{label: string, value: string | number | null | undefined}>} An array of label-value pairs with initiative information
 */
const getInitiativeInfo = (
  initiative: Initiative,
  t: TFunction,
): { label: string; value: string | number | null | undefined }[] => {
  return [
    {
      label: t('strategy.initiative_performance.start_date'),
      value: formatInitiativeDate(initiative.start_date, t),
    },
    {
      label: t('strategy.initiative_performance.activity_start_date'),
      value: formatInitiativeDate(initiative.effective_start_date, t),
    },
    {
      label: t('strategy.initiative_performance.end_date'),
      value: formatInitiativeDate(initiative.end_date, t),
    },
    {
      label: t('strategy.initiative_performance.activity_end_date'),
      value: formatInitiativeDate(initiative.effective_end_date, t),
    },
  ];
};

export { getInitiativeInfo };
